// This component is a simplified fork of the AIBadge component in the ai-components-ui-library
// The main visual difference is using the text "Breeze" instead of "AI"
// Storybook: https://private.hubteamqa.com/ai-components-ui-library-storybook/?path=/docs/breeze-informative-aibadge--page
// Sourcegraph: https://sourcegraph.hubteam.com/git.hubteam.com/HubSpot/ai-components-ui-library@264f86f956990c55e077f7326bdb4541a609dfb8/-/blob/ai-components-ui-library/static/js/components/informative/AIBadge.tsx
// Github: https://git.hubteam.com/HubSpot/ai-components-ui-library/blob/master/ai-components-ui-library/static/js/components/informative/AIBadge.tsx
import { BreezeSingleStarIcon } from 'foundations-assets/icons/components/BreezeSingleStarIcon';
import styled from 'styled-components';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const ContentWrapper = styled.div.withConfig({
  displayName: "BreezeBadge__ContentWrapper",
  componentId: "sc-4klljb-0"
})(["", ""], ({
  theme
}) => {
  return {
    alignItems: 'center',
    background: theme.color['breeze-fill-special-btn-alt-default'],
    border: 'none',
    borderRadius: theme.borderRadius['200'],
    color: theme.color['fill-surface-default'],
    display: 'flex',
    fontSize: '10px',
    fontWeight: theme.typography['body-100'].fontWeight,
    height: theme.space['500'],
    justifyContent: 'center',
    padding: theme.space['0'],
    userSelect: 'none',
    width: theme.space['1200']
  };
});
const IconWrapper = styled.span.withConfig({
  displayName: "BreezeBadge__IconWrapper",
  componentId: "sc-4klljb-1"
})(["", ""], ({
  theme
}) => {
  return {
    fontSize: '8px',
    lineHeight: theme.typography['heading-100'].lineHeight,
    marginRight: theme.space['50'],
    verticalAlign: 'top',
    transform: 'translateY(1px)'
  };
});
export const BreezeBadge = () => {
  return /*#__PURE__*/_jsxs(ContentWrapper, {
    children: [/*#__PURE__*/_jsx(IconWrapper, {
      children: /*#__PURE__*/_jsx(BreezeSingleStarIcon, {})
    }), /*#__PURE__*/_jsx("span", {
      children: "Breeze"
    })]
  });
};